import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import * as Yup from "yup";
import Edit from "../../../../assets/images/editinput.svg";
import {Countries as countries} from "../../../../services/countries";
import "../../../../styles/userManagement.css";
import view from "../../../../assets/images/view 1.svg";
import closedeye from "../../../../assets/images/icon-eye-closed.svg";
import PasswordStrength from "../../../Common/PasswordStrength";
import {Select} from "@appkit4/react-components/select"
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp"
import PropTypes from 'prop-types';
export default function CreateVendor(props) {
  const [loading, setLoading] = useState(false);
  const [validations] = useState("");
  const [isConfirmPassword, setIsConfirmPassword] = useState(true);
  const [selectedThirdParty, setSelectedThirdParty] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState();
  const [email, setEmail] = useState();
  const [country, setCountry] = useState();
  const [businessUnit, setBusinessUnit] = useState();
  const [subBusinessUnit, setSubBusinessUnit] = useState();
  const [vendorReviewer, setVendorReviewer] = useState("");
  const [reviewerEmail, setReviewerEmail] = useState("");
  const { sendRequest: vendorRegistration } = useHttp();
  const { sendRequest: getTPListDetails } = useHttp();
  const { sendRequest: getTPContactInfo } = useHttp();
  let {
    SetTab,
    getVendorListData,
    Vendors,
    VendorBusinessUnitList,
    VendorSubBusinessUnitList,
  } = props;
  const handleSubmit = async (values, { resetForm }) => {
    setLoading(true);
    values.createdBy = Number(sessionStorage.getItem("userId"));
    values.thirdPartyEmail = email;
    values.vendorReviewer = vendorReviewer;
    values.reviewerEmail = reviewerEmail;
    try {
      vendorRegistration(APIService.vendorRegistration(values),
      (data) => {
        if (data.CODE) {
          resetForm();
          SetTab(0);
          getVendorListData();
          setLoading(false);
          displayToastMessage(data.MSG, "success");
        } else {
          let Msg = "Action failed. Please try again!";
          setLoading(false);
          displayToastMessage(Msg, "error");
        }
      })
    } catch (error) {
      console.log("Error",error)
      setLoading(false);
      let Msg = "Third Party Account already exist, Please create new account";
      displayToastMessage(Msg, "error");
    }
  };



  const handleReset = () => {
    SetTab(0);
    setPhoneNumber("");
    setEmail("");
    setCountry("");
    setBusinessUnit("");
    setSubBusinessUnit("");
    setVendorReviewer("");
    setReviewerEmail("");
  };
  const getThirdPartyDetails = async (e) => {
    getTPContactInfo(APIService.getTPContactInfo(e), (data) => {
      if (data) {
        setPhoneNumber(data.MSG[0].vendorPhoneNumber);
        setEmail(data.MSG[0].email);
        setCountry(data.MSG[0].country);
        setBusinessUnit(data.MSG[0].department);
        setSubBusinessUnit(data.MSG[0].subDepartment);
        if(data.MSG[0].reviewer !== null) {
          setVendorReviewer(data.MSG[0].reviewer)
        }
        else{
          setVendorReviewer("")
        }
        if(data.MSG[0].revieweremail !== null){
          setReviewerEmail(data.MSG[0].revieweremail)
        }
        else{
          setReviewerEmail("")
        }
      }
    })
  };
  useEffect(() => {
  }, []);
  const handleConfirmPassword = () => {
    setIsConfirmPassword((prev) => !prev);
  };
  const getSelectedThirdParty = async (e) => {
    getTPListDetails(APIService.getTPListDetails(e), (result) => {
      if (result.CODE) {
        setSelectedThirdParty(result.MSG);
      }
    })
  };

  const handleReviewerChange = (e) => {
    setVendorReviewer(e.target.value)
  } 

  const handleReviewerEmail = (e) => {
    setReviewerEmail(e.target.value)
  }
 const InitialValues={
    thirdPartyID: "",
    Vendorcontact: "",
    Email: "",
    Password: "",
    vendorReviewer: "",
    changepassword: "",
    reviewerEmail:"",
  }

  let validationSchema = Yup.object().shape({
    thirdPartyID: Yup.number().required("Please select third party name"),
    Vendorcontact: Yup.string()
      .required("Third Party Contact is Required")
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
      vendorReviewer:Yup.string()
      .matches(
        /^[a-zA-Z\d\-_.,&#()\s]+$/,
        "Only alphabets, numbers and some special characters are allowed for this field "
      ),
      reviewerEmail:Yup.string().email(),
    Password: Yup.string()
      .required("Password is Required")
      .min(8, "Password is too short - should be 8 chars minimum.")
      .matches(/(?=.*[0-9])/, "Password must contain a number."),
    //vendorReviewer:Yup.string().required("Third party reviewer is Required"),
    changepassword: Yup.string().when("Password", {
      is: (val) => (!!(val && val.length > 0)),
      then: Yup.string().oneOf(
        [Yup.ref("Password")],
        "Both password need to be the same"
      ),
    }),
  });
  return (
    <Formik
    initialValues={InitialValues}
      onReset={handleReset}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {(props) => {
        const {
          values,
          touched,
          errors,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
        } = props;
        return (
          <div className="create-vendor-form-container">
            {loading ? (
              <div className="row" id="preloader">
              <div className="col-12 col-lg-12 loader-margin text-center">
                <div className="a-loading a-primary a-m-10">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="Third Party Name" className="cv-input-label">
                        Third Party Name <span className="asterisk-required">*</span>
                      </label>
                      <Select
                        className="cv-input-field"
                        data={Vendors}
                        labelKey="vendor_name"
                        valueKey="vendor_id"
                        onSelect={(e) => {
                          handleChange("thirdPartyID")({
                            target: { value: e },
                          });
                          getSelectedThirdParty(e);
                        }}
                        name="thirdPartyID"
                        value={values.thirdPartyID}
                        placeholder="Select third party name"
                        searchable={true}
                      >
                      </Select>
                    </div>
                    {errors.thirdPartyID && touched.thirdPartyID && (
                      <div className="form-label error">
                        {errors.thirdPartyID}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="Third Party Contact" className="cv-input-label">
                        Third Party Contact <span className="asterisk-required">*</span>
                      </label>
                      <Select
                        className="cv-input-field"
                        data={selectedThirdParty}
                        valueKey="user_id"
                        labelKey="contactname"
                        onSelect={(e) => {
                          handleChange("Vendorcontact")({
                            target: { value: e },
                          });
                          getThirdPartyDetails(e);
                        }}
                        name="Vendorcontact"
                        value={values.Vendorcontact}
                        placeholder="Select third party contact"
                      >
                      </Select>
                    </div>
                    {errors.Vendorcontact && touched.Vendorcontact && (
                      <div className="form-label error">
                        {errors.Vendorcontact}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="thirdPartyEmailCreateVendor" className="cv-input-label">
                        Third Party Email <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        type="email"
                        id="thirdPartyEmailCreateVendor"
                        onBlur={handleBlur}
                        placeholder="Please enter third party email"
                        value={email}
                        onChange={handleChange("VendorEmail")}
                        name="Vendor_Email"
                        disabled
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.VendorEmail && touched.VendorEmail && (
                      <div className="form-label error">
                        {errors.VendorEmail}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="PhoneNumberCreateVendor" className="cv-input-label pl-2">
                        Phone Number <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        type="tel"
                        id="PhoneNumberCreateVendor"
                        placeholder="Please enter phone number"
                        value={phoneNumber}
                        onChange={handleChange("phoneNumber")}
                        name="phoneNumber"
                        disabled
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    {errors.phoneNumber && touched.phoneNumber && (
                      <div className="form-label error">
                        {errors.phoneNumber}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="PasswordCreateVendor" className="cv-input-label">
                        Password <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="PasswordCreateVendor"
                        type="password"
                        placeholder="Please enter password"
                        value={values.Password}
                        onChange={handleChange("Password")}
                        name="Password"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                    <PasswordStrength password={values.Password} />
                    <div>
                      {validations && (
                        <div className="form-label errorMsg">{validations}</div>
                      )}
                    </div>
                    {errors.Password && touched.Password && (
                      <div className="form-label error">{errors.Password}</div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="ConfirmPasswordCreateVendor" className="cv-input-label">
                        Confirm Password <span className="asterisk-required">*</span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        id="ConfirmPasswordCreateVendor"
                        placeholder="Please enter confirm password"
                        type={isConfirmPassword ? "password" : "text"}
                        value={values.changepassword}
                        onChange={handleChange("changepassword")}
                        name="changepassword"
                      />
                      <input
                        type="image"
                        src={isConfirmPassword ? view : closedeye}
                        alt="new"
                        title={
                          isConfirmPassword ? "Show Password" : "Hide Password"
                        }
                        onClick={handleConfirmPassword}
                      />
                    </div>
                    {errors.changepassword && touched.changepassword && (
                      <div className="form-label error">
                        {errors.changepassword}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Business Unit <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={businessUnit}
                        onChange={handleChange("businessUnit")}
                        name="businessUnit"
                        disabled
                      >
                        <option key="0">Select Business Unit</option>
                        {VendorBusinessUnitList?.map((each, index) => {
                            return (
                              <option
                                key={each.vendor_department_name}
                                value={each.vendor_department_id}
                              >
                                {each.vendor_department_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.businessUnit && touched.businessUnit && (
                      <div className="form-label error">
                        {errors.businessUnit}
                      </div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Sub Business Unit <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={subBusinessUnit}
                        onChange={handleChange("subBusinessUnit")}
                        name="subBusinessUnit"
                        disabled
                      >
                        <option key="0">Select Sub-Business Unit</option>
                        {VendorSubBusinessUnitList?.map((each, index) => {
                            return (
                              <option
                                key={each.vendor_subdepartment_name}
                                value={each.vendor_subdepartent_id}
                              >
                                {each.vendor_subdepartment_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.subBusinessUnit && touched.subBusinessUnit && (
                      <div className="form-label error">
                        {errors.subBusinessUnit}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="ThirdPartyReviewerCreateVendor" className="cv-input-label">
                        Third Party Reviewer <span className="asterisk-required"></span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        type="text"
                        id="ThirdPartyReviewerCreateVendor"
                        placeholder="Please enter third party reviewer"
                       value={vendorReviewer}
                        onChange={handleReviewerChange}
                        name="vendorReviewer"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="ReviewerEmailCreateVendor" className="cv-input-label">
                        Reviewer Email <span className="asterisk-required"></span>
                      </label>
                      <input
                        className="cv-input-field pl-2"
                        onBlur={handleBlur}
                        type="email"
                        id="ReviewerEmailCreateVendor"
                        placeholder="Please enter reviewer email"
                        value={reviewerEmail}
                        onChange={handleReviewerEmail}
                        name="Email"
                      />
                      <img alt="edit" src={Edit} className="edit-input" />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Country <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="email"
                        value={country}
                        onChange={handleChange("country")}
                        name="country"
                        disabled
                      >
                        <option key="0">Select Country</option>
                        {countries.map((each, index) => {
                          return (
                            <option key={each.name} value={each.code}>
                              {each.name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    {errors.country && touched.country && (
                      <div className="form-label error">{errors.country}</div>
                    )}
                  </div>
                  
                </div>
                
                <div className="options-container">
                  <button
                    className="cancel-button"
                    type="reset"
                    onClick={handleReset}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="save-button m-l-2"
                  >
                    Submit
                  </button>
                </div>
              </form>
            )}
          </div>
        );
      }}
    </Formik>
  );
}

CreateVendor.propTypes = {
  SetTab: PropTypes.any,
  getVendorListData: PropTypes.any,
  Vendors: PropTypes.any,
  VendorBusinessUnitList: PropTypes.any,
  VendorSubBusinessUnitList: PropTypes.any,
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  isSubmitting: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
  handleReset: PropTypes.any,
}
